<template>
  <div >
    <div class="row">
      <legend>Domicilio {{titulo}}
        <b-button class="btn-popover" v-b-popover.hover.top="popover" v-if="popover != ''"><i class="far fa-question-circle"></i></b-button>
      </legend>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <label class="control-label">Se encuentra en</label>
        <p-radio class="d-inline-block" v-model="lugar" data-vv-name="lugarv" name="lugarv" v-validate="'required'" label="1">México</p-radio>
        <p-radio class="d-inline-block" v-model="lugar" data-vv-name="lugarv" name="lugarv" v-validate="'required'" label="2">Extranjero</p-radio>
        <small class="text-danger">{{ getError('lugarv') }}</small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-8">
        <label class="control-label">Nombre de la Calle</label>
        <input name="vialidadv" data-vv-name="vialidadv" v-validate="'required'" class="form-control" type="text" v-model="domicilio.vialidad_nombre" placeholder="Nombre de la vía" />
        <small class="text-danger">{{ getError('vialidadv') }}</small>
      </div>
      <div class="form-group col-2">
        <label class="control-label">No. Ext.</label>
        <input class="form-control" data-vv-name="extv" type="text" name="extv" v-validate="'required'" v-model="domicilio.ext" placeholder="Número Exterior." />
        <small class="text-danger">{{ getError('extv') }}</small>
      </div>
      <div class="form-group col-2">
        <label class="control-label">No. Int.</label>
        <input class="form-control" data-vv-name="int" type="text" name="int" v-model="domicilio.int" placeholder="Número Interior." />
      </div>
      <div class="form-group col-4" v-if="lugar == '1'">
        <label class="control-label">Entidad Federativa</label>
        <el-select  clearable class="select-default" data-vv-name="entidadv" name="entidadv" v-validate="'required'" filterable placeholder="Entidad" v-model="domicilio.entidadF" v-on:change="getMunicipios">
          <el-option v-for="option in entidades" class="select-default" :value="option.id" :label="option.nom_ent" :key="option.nom_ent"></el-option>
        </el-select>
        <small class="text-danger">{{ getError('entidadv') }}</small>
      </div>
      <div class="form-group col-4" v-if="lugar == '1'">
        <label class="control-label">Municipio / Alcaldia</label>
        <el-select  clearable name="municipiov" :disabled="!municipios" data-vv-name="municipiov" v-validate="'required'" class="select-default" filterable placeholder="Municipio" v-model="domicilio.municipio" v-on:change="getLocalidades">
          <el-option v-for="option in municipios" class="select-default" :value="option.id" :label="option.nom_mun" :key="option.nom_mun"></el-option>
        </el-select>
        <small class="text-danger">{{ getError('municipiov') }}</small>
      </div>
      <div class="form-group col-4" v-if="lugar == '1'">
        <label class="control-label">Colonia / Localidad</label>
        <input name="coloniav" data-vv-name="coloniav" v-validate="'required'" class="form-control" type="text" v-model="domicilio.colonia" placeholder="Colonia" v-on:change="$emit('change', $event.target)" />
        <small class="text-danger">{{ getError('coloniav') }}</small>
      </div>
      <div class="form-group col-4" v-if="lugar == '2'">
        <label class="control-label">País</label>
        <el-select  clearable name="paisv" data-vv-name="paisv" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="domicilio.pais_id">
          <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor"></el-option>
        </el-select>
        <small class="text-danger">{{ getError('paisv') }}</small>
      </div>
      <div class="form-group col-4" v-if="lugar == '2'">
        <label class="control-label">Estado / Provincia</label>
        <input name="estadoprovienciav" data-vv-name="estadoprovienciav" v-validate="'required'" class="form-control" type="text" v-model="domicilio.estadoproviencia" placeholder="Estado/Provincia" v-on:change="$emit('change', $event.target)" />
        <small class="text-danger">{{ getError('estadoproviencia') }}</small>
      </div>
      <div class="form-group col-4" v-if="lugar == '2'">
        <label class="control-label">Ciudad / Localidad</label>
        <input name="coloniav" data-vv-name="coloniav" v-validate="'required'" class="form-control" type="text" v-model="domicilio.colonia" placeholder="Colonia" v-on:change="$emit('change', $event.target)" />
        <small class="text-danger">{{ getError('coloniav') }}</small>
      </div>
      <div class="form-group col-4">
        <label class="control-label">CP</label>
        <input name="cpv" data-vv-name="cpv" v-validate="'required|integer'" class="form-control" maxlength="5" type="text" v-model="domicilio.cp" placeholder="Código Postal" />
        <small class="text-danger">{{ getError('cpv') }}</small>
      </div>
    </div>
    <div class="row">
      <div style="display:none">
        <div class="form-group col-4" v-if="lugar == '1'">
          <label class="control-label">Localidad</label>
          <el-select  clearable name="localidadv" data-vv-name="localidadv" class="select-default" filterable placeholder="Localidad" v-model="domicilio.localidad">
            <el-option v-for="option in localidades" class="select-default" :value="option.id" :label="option.nom_loc" :key="option.cve_loc"></el-option>
          </el-select>
          <!-- <small class="text-danger">{{ getError('localidadv') }}</small> -->
        </div>
        <div class="form-group col-4">
          <label class="control-label">Tipo de Víalidad</label>
          <input name="tvialidadv" data-vv-name="tvialidadv" class="form-control" type="text" v-model="domicilio.vialidad" placeholder="(Calle, Avenida, Bulevar, Callejón)" />
          <!-- <small class="text-danger">{{ getError('tvialidadv') }}</small> -->
        </div>
      </div>
      <div class="form-group col-12" v-if="vista">
        <label>Aclaraciones y observaciones del domicilio</label>
        <textarea class="form-control" type="text" name="domicilio_observaciones" v-model="domicilio.domicilio_observaciones" placeholder="Aclaraciones y observaciones"></textarea>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select
  } from "element-ui";
  /* import {
    mapFields
  } from "vee-validate"; */
  export default {
    // De esta manera se Injecta el vee validate del padre al hijo y no requiere mas funciones o validaciones extra
    inject: ['$validator'],
    /* Inicialización de props con valores default en caso de no recibir parámetros */
    props: {
      value: {
        type: Object,
        default: () => {}
      },
      titulo: {
        type: String,
        default: () => ''
      },
      vista: {
        type: Boolean,
        default: () => true
      },
      popover: {
        type: String,
        default: () => ''
      },
    },
    /* props: ["value", "titulo", "vista"], */
    components: {
      [Tag.name]: Tag
    },
    data() {
      return {
        /* paises: {}, */
        municipios: {},
        localidades: {},
        /* entidades: {}, */
        lugar: "1",
        /*  validaciones: {
           lugarv: {
             required: true
           },
           entidadv: {
             required: true
           },
           municipiov: {
             required: true
           },
           paisv: {
             required: true
           },
           localidadv: {
             required: true
           },
           coloniav: {
             required: true
           },
           tvialidadv: {
             required: true
           },
           vialidadv: {
             required: true
           },
           cpv: {
             required: true,
             numeric: true
           },
           extv: {
             required: true
           },
           estadoproviencia: {
             required: true
           }
         } */
      };
    },
    watch: {
      lugar: function () {
        if (this.lugar == "1") {
          this.domicilio.pais_id = 150;
        }
      },
      "domicilio.entidadF": function (val) {
          this.municipios={};
          this.domicilio.municipio='';

        if (this.domicilio.entidadF) {

          this.getMunicipios();

        }
      },
      "domicilio.municipio": function (val) {
        //console.log(val);
        if (this.domicilio.municipio) {
          //this.getLocalidades();
        }
      },
      "domicilio.pais_id": function (val) {
        //console.log(val);
        if (this.domicilio.pais_id != 150 && this.domicilio.pais_id) {
          this.lugar = "2";
          this.domicilio.municipio = "";
          this.domicilio.entidadF = "";
          this.domicilio.localidad = "";
        } else {
          this.lugar = "1";
        }
      }
    },
    computed: {
      domicilio: {
        get() {
          return this.value ? this.value : {
            type: "Object"
          };
        },
        set(domicilio) {
          this.$emit("input", domicilio);
        }
      },
      /* ...mapFields(["lugarv", "entidadv", "paisv", "localidadv", "coloniav", "tvialidadv", "vialidadv", "municipiov", "cpv", "extv", "estadoproviencia"]) */
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      /* validate(campos) {
        var promesas = [];
        var totalCampos = campos.length;
        for (var i = 0; i < totalCampos; i++) {
          promesas[i] = this.$validator.validate(campos[i]);
        }
        return Promise.all(promesas);
      }, */
      getPaises() {},
      getEntidades() {
        /* this.$http.get('entidadFed').then(response => {
          this.entidades = response.data.entidadfed;
          if (this.domicilio.entidadF) {
            this.getMunicipios();
          }
        }, error => {
          this.StepError(error);
          //console.log(error);
        }) */
        if (this.domicilio.entidadF) {
          this.getMunicipios();
        }
      },
      getMunicipios() {

          this.municipios={};
          if(this.domicilio.entidadF){ 
            this.$http.get("municipios/" + this.domicilio.entidadF).then(response => {
            this.municipios = response.data.municipios;
            if (this.domicilio.municipio) {
              this.getLocalidades();
            }
            }, error => {
              this.StepError(error);
            });
          }
      },
      getLocalidades() {
       /* this.$http.get("localidades/" + this.domicilio.municipio).then(response => {
          this.localidades = response.data.localidades;
        }, error => {
          this.StepError(error);
          //console.log(error);
        });
        */
      }
    },
    created() {
      /* this.$http.get('paises').then(response => {
        this.paises = response.data.pais;
      }, error => {
        this.StepError(error);
        //console.log(error);
      }); */
      this.getEntidades();
      if (this.domicilio.pais_id != 150 && this.domicilio.pais_id) {
        this.lugar = "2";
        this.domicilio.municipio = "";
        this.domicilio.entidadF = "";
        this.domicilio.localidad = "";
      }
    },
    mounted() {
      this.checkCatalogs();
    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Domicilio.vue